import { inject, InjectionToken } from '@angular/core';
import { UnleashClient } from 'unleash-proxy-client';

import { APP_CONFIG } from '../injectionTokens';

export interface UnleashSource {
    on(event: string, callback: () => void): unknown;
    getAllToggles(): { name: string; enabled: boolean }[];
    start(): Promise<void>;
}

export const UNLEASH_CLIENT = new InjectionToken<UnleashSource | null>('UNLEASH_CLIENT', {
    providedIn: 'root',
    factory: () => {
        const { unleash } = inject(APP_CONFIG);

        if (!unleash?.proxyUrl || !unleash.clientKey) return null;

        return new UnleashClient({
            url: unleash.proxyUrl,
            clientKey: unleash.clientKey,
            refreshInterval: unleash.refreshInterval,
            appName: unleash.appName,
        });
    },
});
